import React, { useState, useEffect } from 'react';
import { 
  Box, 
  Button, 
  TextField, 
  Typography, 
  Grid,
  CircularProgress,
  Alert
} from '@mui/material';

const BusinessInfoStep = ({ data, onUpdate, onNext, onBack }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [businessInfo, setBusinessInfo] = useState({
    name: data.name || '',
    description: data.description || ''
  });

  // Log the data received
  useEffect(() => {
    console.log('BusinessInfoStep received data:', JSON.stringify(data, null, 2));
  }, [data]);

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setBusinessInfo(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      // Validate inputs
      if (!businessInfo.name.trim()) {
        setError('Business name is required');
        setLoading(false);
        return;
      }
      
      // Update parent component with form data
      onUpdate({
        businessInfo: {
          name: businessInfo.name.trim(),
          description: businessInfo.description.trim()
        }
      });
      
      // Move to next step
      onNext();
    } catch (err) {
      console.error('Error in BusinessInfoStep:', err);
      setError('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 600, mx: 'auto' }}>
      <Typography variant="h6" gutterBottom>Business Information</Typography>
      
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
      )}
      
      <Grid container spacing={2}>
        {/* Business Name */}
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Business Name"
            name="name"
            value={businessInfo.name}
            onChange={handleInputChange}
            required
            margin="normal"
            variant="outlined"
            placeholder="Your Business Name"
            inputProps={{
              'aria-label': 'Business name',
              'data-testid': 'business-name-input'
            }}
          />
        </Grid>
        
        {/* Business Description */}
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Business Description"
            name="description"
            value={businessInfo.description}
            onChange={handleInputChange}
            margin="normal"
            variant="outlined"
            multiline
            rows={4}
            placeholder="Describe what your business does..."
            inputProps={{
              'aria-label': 'Business description',
              'data-testid': 'business-description-input'
            }}
          />
        </Grid>
        
        {/* Navigation Buttons */}
        <Grid item xs={12} sx={{ mt: 3, display: 'flex', justifyContent: 'space-between' }}>
          <Button 
            onClick={onBack}
            variant="outlined"
          >
            Back
          </Button>
          
          <Button 
            type="submit" 
            variant="contained"
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : 'Continue'}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default BusinessInfoStep; 